<template>
    <div class="student-info">
        <h4 class="title"><img class="icon-box" src="//file.40017.cn/appresource/image/forStudent/new/icon-studentHat@3x.png" alt="">同程学生证</h4>
        <div class="info-box">
            <img class="header-img" :src="data.avatar" alt=""/>
            <div class="info">
                <h5 class="key-box">姓名/NAME</h5>
                <p class="name-box">{{data.name}}</p>
                <h5 class="key-box">院校/COLLEGE</h5>
                <p class="name-box">{{data.school}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, Icon } from 'vant';
import { toPage, randomString } from "@/utils/tools";

export default {
    name: 'studentInfo',
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        [Icon.name]: Icon,
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
       
    }
}
</script>

<style lang="less" scoped>
.student-info {
    position: relative;
    // top: -38px;
    background: #fff url(//file.40017.cn/appresource/image/forStudent/new/bg_s_userinfo.png) no-repeat;
    background-size: cover;
    margin: 0 12px;
    margin-top: -121px;
    border-radius: 8px;
    padding: 12px;
    .title {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        .icon-box {
            display: inline-block;
            width: 26px;
            height: 22px;
            line-height: 26px;
            margin-right: 8px;
        }
    }
    .info-box {
        display: flex;
        align-items: center;
        padding-top: 8px;
        .header-img {
            align-self: flex-start;
            display: inline-block;
            width: 32px;
            height: 32px;
            border: 1px solid #FFFFFF;
            border-radius: 20px;
            margin-right: 10px;
        }
        .info {
            .key-box {
                font-size: 12px;
                font-weight: 400;
                color: #888888;
                margin-top: 12px;
                margin-bottom: 6px;
                &:first-child {
                    margin-top: 0;
                }
            }
            .name-box {
                font-weight: 500;
                font-size: 14px;
                color: #333333;
            }
        }
    }
}
</style>>
